import { render, staticRenderFns } from "./mailSettingEdit.vue?vue&type=template&id=2fa0f615&scoped=true&"
import script from "./mailSettingEdit.vue?vue&type=script&lang=js&"
export * from "./mailSettingEdit.vue?vue&type=script&lang=js&"
import style0 from "./mailSettingEdit.vue?vue&type=style&index=0&id=2fa0f615&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0f615",
  null
  
)

export default component.exports